/**
 * 图片节点「角色」：POST /node_character_design
 */

import { resolveApiUrl } from './apiBaseUrl'

function getToken() {
  if (typeof localStorage === 'undefined') return ''
  return localStorage.getItem('token') || sessionStorage.getItem('token') || ''
}

function unwrapPayload(res) {
  if (res == null || typeof res !== 'object') return {}
  let d = res.data != null && typeof res.data === 'object' ? res.data : res
  for (let i = 0; i < 4; i++) {
    if (!d || typeof d !== 'object' || Array.isArray(d)) break
    if (
      (typeof d.paint_prompt_en === 'string' && d.paint_prompt_en.trim()) ||
      (typeof d.paintPromptEn === 'string' && d.paintPromptEn.trim()) ||
      (typeof d.raw === 'string' && d.raw.trim()) ||
      (typeof d.assistant_raw === 'string' && d.assistant_raw.trim())
    ) {
      break
    }
    if (d.data != null && typeof d.data === 'object' && !Array.isArray(d.data)) {
      d = d.data
      continue
    }
    break
  }
  return d && typeof d === 'object' ? d : {}
}

function extractPaintPromptFromAssistantText(text) {
  let full = String(text || '').trim()
  if (!full) return ''
  full = full.replace(/^```(?:english|text|markdown)?\s*/i, '').replace(/\s*```\s*$/i, '')
  if (/【需要补充】/u.test(full) && !/【绘图提示词】/u.test(full)) {
    return ''
  }
  const pm = full.match(/【绘图提示词】\s*[:：]?\s*([\s\S]+)/u)
  if (pm && pm[1]) {
    const p = String(pm[1]).trim()
    if (p) return p
  }
  if (/character design sheet|turnaround/i.test(full)) return full
  if (/^[\x20-\x7E\n\r\t\u2013\u2014-]+$/u.test(full) && full.length > 40) return full
  return full
}

/**
 * @param {string} prompt 用户描述（可含【已选风格】元信息）
 * @param {{ model?: string, signal?: AbortSignal }} [opts]
 * @returns {Promise<{ paintPromptEn: string, raw: string }>}
 */
export async function fetchNodeCharacterDesignPrompt(prompt, opts = {}) {
  const text = String(prompt || '').trim()
  if (!text) {
    throw new Error('请输入角色形象描述')
  }

  const body = { prompt: text }
  if (opts && opts.model != null && String(opts.model).trim()) {
    body.model = String(opts.model).trim()
  }

  let res
  try {
    res = await fetch(resolveApiUrl('/node_character_design'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getToken()
      },
      body: JSON.stringify(body),
      signal: opts && opts.signal
    })
  } catch (e) {
    const m = e && e.message ? String(e.message) : String(e)
    throw new Error(/failed to fetch|networkerror|cors/i.test(m) ? `角色扩写请求失败：${m}` : m)
  }

  const rawText = await res.text()
  let data
  try {
    data = JSON.parse(rawText)
  } catch {
    data = { raw: rawText }
  }

  if (!res.ok) {
    const msg =
      (data && (data.message || data.msg || data.error)) || rawText.slice(0, 400) || `HTTP ${res.status}`
    throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg))
  }

  const bizCode = data && data.code != null ? Number(data.code) : 0
  if (!Number.isNaN(bizCode) && bizCode !== 0) {
    const msg = (data && (data.message || data.msg || data.error)) || '角色扩写失败'
    throw new Error(typeof msg === 'string' ? msg : JSON.stringify(msg))
  }

  const payload = unwrapPayload(data)
  const assistantRaw =
    (payload && typeof payload.raw === 'string' && payload.raw) ||
    (payload && typeof payload.assistant_raw === 'string' && payload.assistant_raw) ||
    ''
  let paintPromptEn =
    (payload && typeof payload.paint_prompt_en === 'string' && payload.paint_prompt_en.trim()) ||
    (payload && typeof payload.paintPromptEn === 'string' && payload.paintPromptEn.trim()) ||
    ''
  if (!paintPromptEn && assistantRaw) {
    paintPromptEn = extractPaintPromptFromAssistantText(assistantRaw)
  }

  if (!paintPromptEn) {
    const hint =
      (data && (data.message || data.msg)) ||
      (assistantRaw ? assistantRaw.slice(0, 120) : '') ||
      rawText.slice(0, 120)
    throw new Error(
      hint && hint !== rawText.slice(0, 120)
        ? `角色扩写失败：${hint}`
        : '角色扩写失败：未返回绘图提示词，请补充更具体的角色描述后重试'
    )
  }

  return {
    paintPromptEn: paintPromptEn.trim(),
    raw: assistantRaw || paintPromptEn
  }
}
